import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/(container)/settings")({
    component: RouteComponent,
});

function RouteComponent() {
    // useEffect(() => {
    //     const init = async () => {
    //         const games = await ChessGameRepository.getAll();
    //
    //         const stats = StatsService.calculateStats(games);
    //         console.log({ stats });
    //     };
    //
    //     init();
    // }, []);
    return <div>Hello "/(container)/settings"!</div>;
}
